/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Cx as Cx,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ii as ii,
  rec_rs as rs,
  rec_uo as uo,
  rec_wx as wx,
} from "../../runtime/index.jsx";
export function AccionAsync({
  children: e,
  onClick: t,
  variante: n = `primario`,
  icono: r = null,
  textoOcupado: i = null,
  ocupado: a = !1,
  disabled: o = !1,
  className: s = ``,
  type: c = `button`,
  ...l
}) {
  let [u, f] = (0, React.useState)(!1),
    p = (0, React.useRef)(!0),
    m = (0, React.useRef)(!1);
  (0, React.useEffect)(
    () => (
      (p.current = !0),
      () => {
        p.current = !1;
      }
    ),
    [],
  );
  let h = (0, React.useCallback)(
      async (e) => {
        if (m.current || a || o) {
          e.preventDefault();
          return;
        }
        if (!t) return;
        rs(`toque`);
        let n = t(e);
        if (n && typeof n.then == `function`) {
          ((m.current = !0), f(!0));
          try {
            await n;
          } catch (e) {
            uo({
              tipo: `AccionSinManejar`,
              mensaje: e?.message || String(e),
              traza: e?.stack,
            });
          } finally {
            ((m.current = !1), p.current && f(!1));
          }
        }
      },
      [t, a, o],
    ),
    g = u || a;
  return (
    <button
      type={c}
      onClick={h}
      disabled={o || g}
      aria-busy={g || void 0}
      className={`${Cx} ${wx[n] ?? wx.primario} ${s}`}
      {...l}
      children={[
        g
          ? (0, JSXRuntime.jsx)(ii, {
              className: `h-4 w-4 shrink-0 animate-spin`,
            })
          : r &&
            (0, JSXRuntime.jsx)(r, {
              className: `h-4 w-4 shrink-0`,
            }),
        g && i ? i : e,
      ]}
    />
  );
}
